import { create } from "zustand";
import { getDefaultRange } from "../utils/month";
import type { MonthRange } from "../types/smsBilling.types";

interface SmsBillingState {
  /** 선택 중인 범위. 조회 버튼을 눌러야 appliedRange 가 된다 */
  draftRange: MonthRange;
  /** 실제 조회에 쓰인 범위. null 이면 아직 조회 전 */
  appliedRange: MonthRange | null;
  /** 업체명 필터 (클라이언트) */
  keyword: string;
  setDraftRange: (range: MonthRange) => void;
  applyRange: () => void;
  setKeyword: (keyword: string) => void;
}

export const useSmsBillingStore = create<SmsBillingState>((set) => ({
  draftRange: getDefaultRange(),
  appliedRange: null,
  keyword: "",
  setDraftRange: (draftRange) => set({ draftRange }),
  applyRange: () => set((s) => ({ appliedRange: { ...s.draftRange } })),
  setKeyword: (keyword) => set({ keyword }),
}));
